import { TRequestorFill, TRequestorFillForm } from '../models'

export const mapRequestorFillDBToForm = (props: TRequestorFill): TRequestorFillForm => ({
  ...props,
  HPSigningEntity: props.HPSigningEntity ? props.HPSigningEntity.replace('&amp;', '&') : null,
  TerritorySale: props.TerritorySale ? props.TerritorySale.split(',') : [],
  TerritorySaleISO: props.TerritorySaleISO ? props.TerritorySaleISO.split(',') : [],
})
